module.exports = __webpack_public_path__ + "static/img/address_empty.b35a666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/address_empty.png
// module id = 8Kyu
// module chunks = 192